import React from 'react'
import "./Upgraded_profile.css"
import Common_recharge_page_banner from '../../common_components/common_banner/common_recharge_page_banner/Common_recharge_page_banner'
import Upgraded_profile_form from './upgraded_profile_form/Upgraded_profile_form'

function Upgraded_profile() {
    return (
        <>
            <section className='Upgraded_profile upgraded_menu_sections'>
                <div className="container">

                    <Common_recharge_page_banner title="PROFILE" className="Upgraded_menu_banner" />
                    <div className="row justify-content-center">
                        <div className="col-lg-7 col-md-10">
                            <div className="profile_tabs_and_content">
                                <div className="section_holder">
                                    <Upgraded_profile_form />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Upgraded_profile